import React from 'react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  return <section className="w-full bg-white py-8 px-4 border-t border-gray-200" data-id="element-172">
      <div className="max-w-2xl mx-auto text-center" data-id="element-173">
        <p className="text-lg font-bold text-gray-500 uppercase tracking-widest mb-4" data-id="element-174">
          La solución
        </p>

        <h2 className="text-4xl md:text-5xl font-black text-black mb-4" data-id="element-175">
          Kit Aprendizaje en Casa
        </h2>

        <p className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-176">
          Un sistema simple para acompañarlo sin discusiones ni frustración.
        </p>

        <p className="text-lg text-gray-600 mb-8" data-id="element-177">
          No es más información. Es saber exactamente qué hacer cuando tu hijo
          no entiende.
        </p>

        <div className="bg-gray-50 border-2 border-gray-200 p-6 mb-8" data-id="element-178">
          <h3 className="text-2xl font-black text-black uppercase mb-8" data-id="element-179">
            Cómo funciona
          </h3>

          <div className="flex flex-col items-center gap-4 text-xl font-bold text-gray-800 mb-10" data-id="element-180">
            <span data-id="element-181">📖 Abrís la guía</span>
            <span className="text-gray-400" data-id="element-182">↓</span>
            <span data-id="element-183">👆 Entendés qué está pasando</span>
            <span className="text-gray-400" data-id="element-184">↓</span>
            <span data-id="element-185">🤝 Aplicás con tu hijo</span>
          </div>

          <div className="space-y-2 text-xl font-black text-red-600" data-id="element-186">
            <p data-id="element-187"> Sin discusiones</p>
            <p data-id="element-188"> Sin tension</p>
            <p data-id="element-189"> Sin sentirte perdido</p>
          </div>
        </div>

        <CTAButton text="👉 QUIERO AYUDAR A MI HIJO SIN PELEAS" href="#compra" className="w-full" data-id="element-190" />
      </div>
    </section>;
}